import {
  Carousel,
} from "react-bootstrap";

type Props = { pathImages: any };

const ProductCarousel = (props: Props) => {
  const { pathImages } = props;

  return <Carousel>
    {pathImages.map((path: any, index: number) =>
      <Carousel.Item key={index}>
        <img
          key={index}
          alt={path}
          className="d-block w-100 rounded"
          src={path}
        />
      </Carousel.Item>
    )}
  </Carousel>
}
export default ProductCarousel